import { client } from './client';
import interceptors from './interceptors';

client.interceptors.request.use(interceptors.auth, interceptors.onError);

function getProvince() {
	return client.get('tunnel/api/public/general/province');
}

function getCity(params) {
	return client.get('tunnel/api/public/general/city', {
		params: params
	});
}

function getDistrict(params) {
	return client.get('tunnel/api/public/general/subdistrict', {
		params: params
	});
}

export default {
	getProvince,
	getCity,
	getDistrict,
}